import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as actions from 'store/actions/index';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { CustomAppEventListener, isSdk } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import CustomDataForm from 'Flow2/components/CustomCollections/CustomDataForm/CustomDataForm';
import CustomErrorBoundry from 'Flow2/components/CustomCollections/CustomDataControllers/CustomErrorBoundry';
import MessageService from 'Flow2/components/Services/MessageService/MessageService';
import AdvancedSearch from 'Flow2/components/AdvancedBox/AdvancedSearch/AdvancedSearch';
import Button from 'Flow2/components/UI/Button/Button';
import ApiTags from 'Flow2/components/CustomCollections/CustomDataApi/CustomDataApi';
import FlexSearchHandler from 'Flow2/components/Share/FlexSearch/FlexSearchHandler/FlexSearchHandler';
import FlexUploadHandler from 'Flow2/components/Share/FlexUpload/FlexUploadHandler/FlexUploadHandler';
import Loader from 'Flow2/components/AdvancedBox/AdvancedUI/Loader/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './CustomDataPage.module.scss';

class CustomDataPage extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    onMinMfUploadClick = () => {
        const { shareDataForm } = this.props.shareObjects;
        if (shareDataForm && shareDataForm[`min${CustomTypes.MASTER_UPLOAD_FORM}`]) {
            this.props.updateShareObjects({
                shareDataForm: { ...shareDataForm, [`click${CustomTypes.MASTER_UPLOAD_FORM}`]: true }
            });
        }
    }


    showDlgMsg = ({ other }) => {
        const { shareDataForm } = this.props.shareObjects;
        MessageService.confirmMsg({
            formatMessage: this.props.intl.formatMessage,
            titleIntl: "Upload Info", textIntl: `customdata.${other}.opened`, cb: () => {
                this.props.updateShareObjects({
                    shareDataForm: { ...shareDataForm, [`click${other}`]: true }
                });
            }
        });
    }

    openForm = () => {
        const { shareDataForm } = this.props.shareObjects;
        if (shareDataForm && shareDataForm[`min${CustomTypes.UPLOAD_FORM}`]) {
            this.showDlgMsg({ other: CustomTypes.UPLOAD_FORM });
        } else {
            if (this.props.formState === 'closed'
                && this.props.showUpload !== 'open'
                && this.props.showExpertSearch !== 'open') {
                this.props.setupCustomForm({ formState: 'opened' });
            }
        }

    }

    toggleExpertSearch = () => {
        const { shareDataForm } = this.props.shareObjects;
        if ((this.props.formState === 'closed' && this.props.showUpload !== 'open')
            || (shareDataForm && shareDataForm[`min${CustomTypes.UPLOAD_FORM}`])) {
            if (this.props.showExpertSearch !== 'open') {
                this.props.searchOpened();
            }
        }
    }

    toogleUpload = () => {
        const { shareDataForm } = this.props.shareObjects;

        if (shareDataForm && shareDataForm[`min${CustomTypes.MASTER_UPLOAD_FORM}`]) {
            this.showDlgMsg({ other: CustomTypes.MASTER_UPLOAD_FORM });
        } else {
            if (this.props.formState === 'closed' && this.props.showExpertSearch !== 'open') {
                if (this.props.showUpload !== 'open') {
                    this.props.uploadOpened();
                }
            }
        }

        if (shareDataForm && shareDataForm[`min${CustomTypes.UPLOAD_FORM}`]) {
            this.props.updateShareObjects({ shareDataForm: { ...shareDataForm, [`click${this.props.formDesign}`]: true } });
        }
    }

    isLoading = () => {
        if (DataUtil.isPorscheArchiv() && this.props.loading) {
            return true;
        }
        return false;
    }

    componentDidUpdate(prev) {
        const { shareDataForm } = this.props.shareObjects;
        if (!prev.shareObjects.shareDataForm[`min${CustomTypes.MASTER_UPLOAD_FORM}`]
            && shareDataForm[`min${CustomTypes.MASTER_UPLOAD_FORM}`]) {
            this.setState({ minMfUp: true });
        }

        if (prev.shareObjects.shareDataForm[`min${CustomTypes.MASTER_UPLOAD_FORM}`]
            && !shareDataForm[`min${CustomTypes.MASTER_UPLOAD_FORM}`]) {
            this.setState({ minMfUp: false })
        }
    }


    render() {
        if (this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) {
            const { masterData } = this.props;
            const clipTitle = DataUtil.getTitleByLangAndAppId(process.env.REACT_APP_APPID, this.props.lg, masterData);
            const clipId = DataUtil.getClipIdByAppId(process.env.REACT_APP_APPID, masterData);
            return (
                <div>
                    <div className={classes.CustomDataPageBtnWrapper}>
                        <Button btnType='Red' clicked={this.openForm}>
                            <FormattedMessage id="infoSection.mediafile.add" />
                        </Button>
                        {this.state.minMfUp && (
                            <div className={classes.CustomDataPageBtnMin} onClick={this.onMinMfUploadClick}></div>
                        )}
                    </div>
                    {(this.props.formState === 'opened') ? (
                        <CustomErrorBoundry formName={CustomTypes.UPLOAD_INTO_MASTER}>
                            <CustomDataForm
                                formTitle={this.props.intl.formatMessage({ id: "customdata.masterUploadMsg" })}
                                formDesign={CustomTypes.MASTER_UPLOAD_FORM}
                                formConfig={this.props.temFormConfig}
                                masterClipId={clipId}
                                formStyle={CustomTypes.MASTER_UPLOAD_STYLE}
                                saveFormData={this.props.saveFormData}
                                masterClipTitle={clipTitle} />
                        </CustomErrorBoundry>) : null}
                </div>)
        } else if (this.props.formDesign === CustomTypes.SEARCH_FORM) {
            return (
                <div className={classes.CustomDataPageExpertSearchBtnWrapper}>
                    <ApiTags />
                    <FlexSearchHandler />
                    <Button btnType='Button_dark' clicked={this.isLoading() ? null : this.toggleExpertSearch} >
                        <FontAwesomeIcon icon={"chevron-right"} style={{ marginRight: '10px' }} />
                        <FormattedMessage id="toolbar.expertSearch.button" />
                        {this.isLoading() && <Loader />}
                    </Button>
                    {(this.props.showExpertSearch === 'open') ? (
                        <CustomErrorBoundry formName={CustomTypes.SEARCH_FORM}>
                            {(DataUtil.isPorscheArchiv() && this.props.config
                                && this.props.config.showNewSearch) ? (
                                <AdvancedSearch />
                            ) : (
                                <CustomDataForm
                                    formTitle={this.props.intl.formatMessage({ id: "customdata.expertSearchMsg" })}
                                    formDesign={CustomTypes.SEARCH_FORM}
                                    formConfig={this.props.expertSearchConfig}
                                    formStyle={DataUtil.isPorscheArchiv() ? CustomTypes.EXPERTSEARCH_XL_STYLE : CustomTypes.EXPERTSEARCH_STYLE}
                                    formIcon={CustomAppEventListener("getIcon", "epSearchIcon")} />
                            )}
                        </CustomErrorBoundry>) : null}
                </div>
            )
        } else if (this.props.formDesign === CustomTypes.UPLOAD_FORM) {
            return (
                <div>
                    {(isSdk() && !this.props.apiMounted) && <ApiTags />}
                    <FlexUploadHandler />
                    <div style={this.props.hideBtn ? { display: "none" } : null}>
                        <Button btnType='Button_dark' clicked={this.toogleUpload}>
                            <FontAwesomeIcon icon={CustomAppEventListener("getAweIcon", "faArrowUp")} />
                            {this.props.open && <span className={classes.ButtonContainer}>
                                <FormattedMessage id="common.upload" /></span>}
                        </Button>
                    </div>
                    {
                        (this.props.showUpload === 'open') ? (
                            <CustomErrorBoundry formName={CustomTypes.UPLOAD_FORM}>
                                <CustomDataForm formTitle={this.props.intl.formatMessage({ id: "customdata.uploadMsg" })}
                                    formDesign={CustomTypes.UPLOAD_FORM}
                                    formConfig={this.props.uploadConfig}
                                    formIcon={CustomAppEventListener("getIcon", "uploadGrayIcon")} />
                            </CustomErrorBoundry>) : null
                    }
                </div>
            )
        }
    }

}

const mapStateToProps = (state) => {
    return {
        formState: state.uploadFiles.formState,
        lg: state.ui.language,
        temFormConfig: state.ui.tempConfig,
        showExpertSearch: state.ui.expertSearchState,
        expertSearchConfig: state.ui.expertSearchConfig,
        showUpload: state.ui.uploadState,
        uploadConfig: state.ui.uploadConfig,
        addFormState: state.customData.addFormState,
        shareObjects: state.share.shareObjects,
        apiMounted: state.customData.customFlexAppConfig.apiMounted,
        config: state.ui.config,
        loading: state.tags.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setupCustomForm: (formState) => dispatch(actions.uploadFormState(formState)),
        saveFormData: (obj) => dispatch(actions.tempSaveData(obj)),
        searchOpened: () => dispatch(actions.expertSearchOpened()),
        searchClosed: () => dispatch(actions.expertSearchClosed()),
        uploadOpened: () => dispatch(actions.uploadOpened()),
        uploadClosed: () => dispatch(actions.uploadClosed()),
        updateShareObjects: (obj) => dispatch(actions.updateShareObjects(obj))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomDataPage));



